import { useMemo } from 'react'
import { useReactiveVar } from '@apollo/client'
import { balanceVar } from 'shared/store/balance-store'
import { activeBalanceClaimSwitchTypeVar } from '../store/switch-types'
import { ClaimBalanceSwitchTypes } from '../types'
import { getFormattedBalances } from '../utils/get-formatted-balances'

export const useApprovedBalanceField = () => {
  const activeType = useReactiveVar(activeBalanceClaimSwitchTypeVar)

  const balance = useReactiveVar(balanceVar)

  const { formattedBalance } = getFormattedBalances(balance)

  const maxAmount = useMemo(() => {
    // NOTE: the exact deposit, not a rounded one: MAX must withdraw all of it
    if (activeType === ClaimBalanceSwitchTypes.Claim) {
      return balance.tokenDeposited
    }

    return formattedBalance
  }, [activeType, formattedBalance, balance.tokenDeposited])

  return { maxAmount, isApprove: false }
}
